import { Basic } from "../basic.ts";
import { debounce, toBool } from "../../lib/utils.js";
import styles from '../../styles/tooltip.css'
import { Converter } from "../../observer/converter.js";
import i18next from "i18next";

/**
 * @class MSDataTree
 * @extends Basic
 * @classdesc Дерево одиночного/множественного выбора
 */
export class MSDataTree extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "datasource",
            "stylestable",
            "stylestableconvertations",
            "sourcetype",
            "multiselect",
            "expanded",
            "idfield",
            "rootidfield",
            "displayfield",
            "value",
            "values",
            "onapply",
            "rootitem",
            "autoselect",
            "filter",
            "filtercallback",
            "childrenfield",
            "flagbackgroundfill",
            "flagtransparency",
            "flagshadowsize",
            "flagshadowcolor",
            "flagcursorview",
            "flagradius",
            "flagindicatorcolor",
            "flagframethickness",
            "flagframecolor",
            "flagframestyle",
            "fontname",
            "fontsize",
            "texthorizontalalign",
            "textverticalalign",
            "fontitalic",
            "fontbold",
            "fontmultiline",
            "fontunderlined",
            "textcolor",
            "expandedlevel",
            "displaynametype",
            "valuetype",
            "issavestate",
            "treestyle",
            "indentationdepth",
            "verticalspacingbetweenitems",
            "itemheight",
            "selecteditemcolor",
            "selecteditembordercolor",
            "selecteditemborderthickness",
            "selecteditemborderstyle",
            "textbackgroundcolor",
        ]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = `
            <style>
                * {
                    box-sizing: border-box;
                }

                :host {
                    flex-direction: column;
                }

                .tree {
                    width: 100%;
                    height: 100%;
                    padding-right: 20px;
                    line-height: normal;
                    user-select: none;
                }

                form {
                    overflow: auto;
                    margin: 0;
                }

                li {
                    position: relative;
                    font-size: 0;
                }

                li:not(:last-child) > label {
                    border-left: 1px solid var(--main-tree-line-color);
                }

                li:not(:last-child) > div label {
                    border-left: 1px solid var(--main-tree-line-color);
                }

                li:not(:last-child) > ul {
                    border-left: 1px solid var(--main-tree-line-color);
                }

                label:before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: var(--label-before-width);
                    height: var(--cl-width);
                    border-bottom: 1px solid var(--main-tree-line-color);
                }

                li:last-child > label:before {
                    border-left: 1px solid var(--main-tree-line-color);
                }

                li:last-child > div label:before {
                    border-left: 1px solid var(--main-tree-line-color);
                }

                .tree .li-before-hidden > label {
                    border: none;
                }

                .tree .li-before-hidden > div label {
                    border: none;
                }

                .tree .li-before-hidden > label:before {
                    border-left: 1px solid var(--main-tree-line-color);
                }

                .tree .li-before-hidden > div label:before {
                    border-left: 1px solid var(--main-tree-line-color);
                }

                .tree .li-before-hidden > ul {
                    border: none;
                }

                .hidden {
                    display: none;
                }

                .tree__searchbox {
                    padding: 5px 5px 5px 8px;
                    border: none;
                    background-color: #ccc;
                    width: 100%;
                }

                .tree__checkbox-wrapper {
                    box-sizing: border-box;
                    display: inline-flex;
                    align-items: center;
                    min-width: var(--font-size);
                    height: var(--font-size);
                    margin-right: 3px;
                    margin-top: 3px;
                }

                .tree__checkbox {
                    display: none;
                }

                input:checked + .tree__checkbox-wrapper .tree__checkbox {
                    display: block;
                }

                label {
                    font-size: 16px;
                }

                    label > div {
                        pointer-events: none;
                        height: var(--label-height);
                        align-content: center;
                        display: inline-grid;
                        width: 100%;
                    }

                    label.select > div {
                        background-color: var(--selected-color);
                        border: var(--selected-border-thickness) var(--selected-border-style) var(--selected-border-color);
                    }

                .tree label {
                    height: calc(var(--label-height) + var(--label-bottom-padding));
                    position: relative;
                    display: var(--label-display);
                    padding: 0 0 var(--label-bottom-padding) var(--label-left-padding);
                    cursor: inherit;
                    align-content: center;
                }

                ul {
                    padding-inline-start: var(--ul-padding-inline-start);
                    list-style: none;
                    margin: 1px 2px;
                    white-space: nowrap;
                    margin: 0;
                    display: var(--ul-display);
                }

                .first {
                    padding-inline-start: var(--ul-first-padding-inline-start);
                }

                .cl {
                    position: absolute;
                    top: 0;
                    left: 0;
                    transform: var(--cl-transform);
                    min-height: 7px;
                    min-width: 7px;
                    width: var(--cl-width);
                    height: var(--cl-height);
                    padding: 0;
                    border: var(--cl-border);
                    border-radius: 2px;
                    background-repeat: no-repeat;
                    background-color: var(--cl-background-color);
                    background-position: 50% 50%;
                    background-image: var(--cl-background-image);
                    background-size: var(--cl-background-size);
                    font-size: var(--cl-font-size);
                    color: var(--main-tree-color);
                    align-content: center;
                    cursor: pointer;
                    z-index: 1;
                }

                .open {
                    background-image: var(--open-background-image);
                    background-size: var(--open-background-size);
                    top: var(--open-top);
                }
                .head-content{
                    display: flex;
                }
                .clear{
                    background: #ADABAB;
                    transition: .3s;
                    cursor: pointer;
                }
                .clear:hover{
                    background: #BCBCBC;
                }
                .clear path{
                    fill: #D9D9D9;
                    transition: .3s;
                }
                .clear:hover path{
                    fill: #EEEEEE;
                }
            </style>
            <style>
                ${styles}
            </style>
            <div class="head-content">
                <div class="tooltip-ignore-hidden">
                    <div class="clear">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 18C13.675 18 15.0938 17.4188 16.2562 16.2563C17.4187 15.0938 18 13.675 18 12C18 10.325 17.4187 8.90625 16.2562 7.74375C15.0938 6.58125 13.675 6 12 6C11.1375 6 10.3125 6.17813 9.525 6.53438C8.7375 6.89063 8.0625 7.4 7.5 8.0625V6H6V11.25H11.25V9.75H8.1C8.5 9.05 9.04688 8.5 9.74062 8.1C10.4344 7.7 11.1875 7.5 12 7.5C13.25 7.5 14.3125 7.9375 15.1875 8.8125C16.0625 9.6875 16.5 10.75 16.5 12C16.5 13.25 16.0625 14.3125 15.1875 15.1875C14.3125 16.0625 13.25 16.5 12 16.5C11.0375 16.5 10.1687 16.225 9.39375 15.675C8.61875 15.125 8.075 14.4 7.7625 13.5H6.1875C6.5375 14.825 7.25 15.9062 8.325 16.7438C9.4 17.5813 10.625 18 12 18Z"/>
                        </svg>
                    </div>
                </div>
            </div>
            <form class="tree"></form>
        `;
        this.separator = "."; // разделитель в пути
        this.idfield = "ID";
        this._winidfield = "id";
        this._displayfield = "Name";
        this._tmpValues = [];
        this.autoselect = true;
        this._onapply = false;
        this.clearBtn = shadowRoot.querySelector(".clear");
        this._main = shadowRoot.querySelector("form");
        this._headerContent = shadowRoot.querySelector(".head-content");
        this._style = shadowRoot.querySelectorAll("style")[0];

        this.controller = new AbortController();
        this.signal = this.controller.signal;

        this.clearBtn.addEventListener("click", () => this.clearState(), {
            signal: this.signal
        });
        this.clearBtn.addEventListener("mouseenter", () => this.showClearBtnTooltip(), {
            signal: this.signal
        });
        this.clearBtn.addEventListener("mouseleave", () => this.hideTooltip(), {
            signal: this.signal
        });
        this._main.addEventListener("click", e => this._onClick(e), {
            signal: this.signal
        });
        this._main.addEventListener("change", e => this._onChange(e), {
            signal: this.signal
        });

        this.datasource = "{}";
        this.sourcetype = this.getAttribute("sourcetype") || 0;
        this.expanded = true;
        this.inited = false;
        this.isFiltered = false;
        this._additionalPath = "";

        this._treestyle = 0;
        this._labelbeforewidth = 19;
        this._firstleftpadding = 30;
        this._itemheight = 0;
        this._indentationdepth = 29;
        this._selecteditemcolor = "#808080";
        this._selecteditembordercolor = "#808080";
        this._selecteditemborderthickness = 0;
        this._verticalspacingbetweenitems = 0;
        this._selecteditemborderstyle = 0;
    }

    afterInitialize() {
        if (this.inited) return;
        this.inited = true;
        if (this.issavestate) {
            this.originPath = this.getOriginPath();
            let storedState = this.getItemState(this.originPath);
            if (storedState) {
                this.openStates = structuredClone(storedState.openStates);
            }
        }
        this.update();
        if (this.sourcetype !== undefined && this.sourcetype > 4) {
            if (this.objectValues) {
                this.updateCheckboxesState();
                return;
            }
            this._calcSelect();
        }
    }

    addSearchbox() {
        const searchbox = this._headerContent.parentNode.querySelector(".tree__searchbox")
        if (searchbox) {
            // При обновлении данных древа не нужно заново создавать searchbox, если он уже есть
            // но нужно очистить поле поиска
            searchbox.value = '';
            this.prevSearchBoxValue = '';
            return;
        }
        const input = document.createElement("input");
        input.type = "text";
        input.placeholder = `${i18next.t('search')}...`;
        input.className = "tree__searchbox";

        input.addEventListener("change", function (e) {
            e.stopPropagation();
            wrapper(e.target.value);

        });

        const wrapper = debounce(val => {
            const newValue = val.toLowerCase();
            if (newValue === this.prevSearchBoxValue) {
                return;
            }
            this.prevSearchBoxValue = newValue;
            this.filterTree(newValue);
        }, 700);

        input.addEventListener("input", function (e) {
            wrapper(e.target.value);
        });

        this._headerContent.prepend(input);
    }

    filterTree(val) {
        if (!this._main) return;
        this.isFiltered = Boolean(val.length)
        const searchValueEmpty = !this.isFiltered

        searchInUl(this._main.querySelectorAll(":scope > ul > li"))

        function searchInUl(liArr) {
            let i = 0;
            const l = liArr.length;
            let needToHideUl;
            let visibleLiCount = l;
            let liBeforeHiddenIndex = -1;
            let prevLiBeforeHiddenIndex = -1;

            while (i < l) {
                const li = liArr[i];
                let label = li.querySelector("label");
                let span = li.querySelector("span");
                const needToHideLi = span
                    ? !span.textContent.toLowerCase().includes(val)
                    : !label.textContent.toLowerCase().includes(val);

                const ul = li.querySelector("ul");

                if (ul) {
                    needToHideUl = searchInUl(ul.childNodes);
                    ul.classList.toggle("hidden", needToHideUl);
                    li.querySelector(".cl").classList.toggle(
                        "hidden",
                        needToHideUl
                    );
                } else {
                    needToHideUl = true;
                }

                const isLiHidden = needToHideLi && needToHideUl;
                if (!isLiHidden && !searchValueEmpty) {
                    const div = li.querySelector(".cl")
                    const ul = li.querySelector("ul")
                    if (div && ul) {
                        div.classList.add("open")
                        ul.style.display = ""
                    }
                } else if (searchValueEmpty) {
                    const div = li.querySelector(".cl")
                    const ul = li.querySelector("ul")
                    if (ul && div) {
                        const isOpen = div.classList.contains("open-without-filter");
                        div.classList.toggle("open", isOpen)
                        ul.style.display = isOpen ? "" : "none"
                    }
                }
                li.classList.toggle("hidden", isLiHidden);

                if (isLiHidden) {
                    visibleLiCount--;

                    const prevLiIndex = i - 1;
                    const prevLi = liArr[prevLiIndex];
                    if (prevLi && !prevLi.classList.contains("hidden")) {
                        liBeforeHiddenIndex = prevLiIndex;
                    }
                }

                if (
                    prevLiBeforeHiddenIndex === -1 &&
                    li.classList.contains("li-before-hidden")
                ) {
                    prevLiBeforeHiddenIndex = i;
                }

                if (i === l - 1) {
                    if (prevLiBeforeHiddenIndex > -1) {
                        liArr[prevLiBeforeHiddenIndex].classList.remove(
                            "li-before-hidden"
                        );
                    }

                    if (
                        liBeforeHiddenIndex > -1 &&
                        visibleLiCount &&
                        visibleLiCount < l
                    ) {
                        liArr[liBeforeHiddenIndex].classList.add(
                            "li-before-hidden"
                        );
                    }

                    needToHideUl = visibleLiCount === 0;
                }

                i++;
            }

            return needToHideUl;
        }
    }

    get expanded() {
        return this._expanded;
    }
    set expanded(v) {
        this._expanded = toBool(v);
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Уровень вложенности:
     * Если 0 - то дерево полностью открыто,
     * Если 1 - то открыты только корневые элементы,
     * И так далее
     * @type {number}
     */
    get expandedlevel() {
        return this._expandedLevel || 0;
    }

    set expandedlevel(v) {
        this._expandedLevel = Math.floor(v);
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Тип отображаемого имени:
     * 0 - имя,
     * 1 - описание
     * @type {enum}
     */
    get displaynametype() {
        return this._displayNameType || 0;
    }

    set displaynametype(v) {
        this._displayNameType = parseInt(v);
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Тип значения:
     * 0 - идентификатор: нужно проставить id и for
     * 1 - путь: id указывать не нужно, при выборе объекта нужно вычислять путь(path)
     * @type {enum}
     */
    get valuetype() {
        return this._valuetype || "0";
    }

    set valuetype(v) {
        this._valuetype = v;
        if (this.inited) {
            this.update();
        }
    }

    // Если true - то это дерево множественного выбора
    // Если false - то это дерево одиночного выбора
    get multiselect() {
        return this._multiselect;
    }
    set multiselect(v) {
        this._multiselect = toBool(v);
    }

    get autoselect() {
        return this._autoselect;
    }
    set autoselect(v) {
        this._autoselect = this._toBool(v);
    }

    get sourcetype() {
        return this._sourcetype;
    }
    set sourcetype(v) {
        if (this._sourcetype === Number(v)) return;
        this._sourcetype = Number(v);
        switch (this._sourcetype) {
            case 0: // ProjectTree
            case 1: // object tree
            case 3: // object window tree
            case 4: // window tree
            case 6: // tree for trend
                if ($pr?.vmInfo?.projectTree) {
                    this._datasource = $pr.vmInfo.projectTree;
                    this._createPath(this._datasource, "Name");
                    if (this.inited) {
                        // надо проверять инициализировался ли компонент или нет,
                        // в противном случае будет происходить двойной рендеринг дерева,
                        // поскольку файл json может загрузиться раньше инициализации
                        this.update();
                        if (this.objectValues) {
                            this.updateCheckboxesState();
                            return;
                        }
                        this._calcSelect();
                    }
                } else {
                    this._loadJSON("VMInfo.json", data => {
                        try {
                            this._datasource = JSON.parse(data).projectTree;
                            this._createPath(this._datasource, "Name");
                            if (this.inited) {
                                // надо проверять инициализировался ли компонент или нет,
                                // в противном случае будет происходить двойной рендеринг дерева,
                                // поскольку файл json может загрузиться раньше инициализации
                                this.update();
                                if (this.objectValues) {
                                    this.updateCheckboxesState();
                                    return;
                                }
                                this._calcSelect();
                            }
                        } catch (e) {
                            console.error(`cannot load tree: ${e.stack}`);
                            this._datasource = [];
                        }
                    });
                }
                break;
            case 2: // CustomJson
                break;
            case 5: // tree for journal
                this._loadJSON("VMJournals.json", data => {
                    try {
                        this._datasource = JSON.parse(data).projectTree;
                        this._createPath(this._datasource, "ID");
                        if (this.inited) {
                            this.update();
                        }
                    } catch (e) {
                        console.error(`cannot load tree: ${e.stack}`);
                        this._datasource = [];
                    }
                });
                break;
        }
    }

    get datasource() {
        return this._datasource;
    }

    set datasource(value) {
        if (value === "{}") {
            return;
        }

        try {
            this._datasource = JSON.parse(value.toString());
            if (this.inited) {
                this.update();
            }
        } catch (e) {
            console.error(`cannot load tree: ${e.stack}`);
            this._datasource = [];
        }
    }

    get stylestable() {
        return this._stylestable;
    }

    set stylestable(v) {
        if (typeof v === "string") {
            try {
                this._stylestable = { value: JSON.parse(v) };
            } catch (e) {
                this._stylestable = {};
            }
        }
        else {
            this._stylestable = v;
        }

        if (v) {
            this.update(true);
        }
    }

    get stylestableconvertations() {
        return this._stylestableconvertations;
    }

    set stylestableconvertations(v) {
        try {
            this._stylestableconvertations = JSON.parse(v)
        } catch (e) {
            this._stylestableconvertations = {};
        }
    }

    get value() {
        return this._value;
    }

    set value(v) {
        this._value = v;
        this._calcSelect();
    }

    get values() {
        return this._values;
    }

    set values(v) {
        try {
            if (typeof v === "string") {
                if (v.startsWith('['))
                    this._values = JSON.parse(v);
                else
                    this._values = v.split(',');
            } else {
                this._values = v;
            }
        } catch (e) {
            console.error(`cannot load values: ${e.stack}`);
            this._values = [];
        }
        this._calcSelect();
    }

    /**
     * @example [{id: "Объекты.Объект 1.Параметр 2", title: "Объект 1.My best param"}]
     */
    get objectValues() {
        return this._objectValues;
    }

    set objectValues(v) {
        this._objectValues = v;
        if (this.inited) {
            this.updateCheckboxesState();
        }
    }

    get onapply() {
        return this._onapply;
    }
    set onapply(v) {
        this._onapply = toBool(v);
    }

    get rootitem() {
        return this._rootitem;
    }

    set rootitem(v) {
        this._rootitem = v;
        this.update();
    }

    // Эти 4 метода - Apply, Cancel, ClearAll и SelectAll можно задать внутри Masterscada.
    // Но для дерева выбора перьев в тренде их задать не получиться
    Apply() {
        this.SetParameter("values", this._tmpValues);
    }

    Cancel() {
        this._calcSelect();
    }

    ClearAll() {
        const checkbox = this._main.querySelectorAll(
            'input[type="checkbox"]:checked'
        );
        checkbox.forEach(el => {
            el.checked = false;
        });
        this._tmpValues = [];
        this.SetParameter("values", this._tmpValues);
    }

    SelectAll() {
        const isValueTypeIdentifier = this.isValueTypeIdentifier();
        const checkbox = this._main.querySelectorAll('input[type="checkbox"]');
        checkbox.forEach(el => {
            el.checked = true;
            this._tmpValues.push(
                isValueTypeIdentifier ? el.id ?? this.generatePath(el) : this.generatePath(el)
            );
        });
        this.SetParameter("values", this._tmpValues);
    }

    isValueTypeIdentifier() {
        return this.valuetype === "0";
    }

    _createPath(data, field, path) {
        data.forEach(el => {
            el.ItemPath = path
                ? `${path}${this.separator}${el[field]}`
                : `${el[field]}` || "";
            if (el?.[this.childrenfield]?.length) {
                this._createPath(el[this.childrenfield], field, el.ItemPath);
            }
        });
    }

    updateCheckboxesState() {
        this._main.querySelectorAll('input[type="checkbox"]').forEach(el => {
            el.checked = this.objectValues.some(x => x.id === el.id);
            if (el.checked && this.autoselect) {
                this._setValues(el.parentNode.closest("li"));
            }
        });
    }

    get pennamelevel() {
        return this._pennamelevel;
    }
    set pennamelevel(v) {
        this._pennamelevel = v;
    }

    get issavestate() {
        return this._issavestate;
    }

    set issavestate(v) {
        this._issavestate = this._toBool(v);
    }

    get idfield() {
        return this._idfield;
    }
    set idfield(v) {
        this._idfield = v;
    }

    get rootidfield() {
        return this._rootidfield;
    }
    set rootidfield(v) {
        this._rootidfield = v;
    }

    get displayfield() {
        return this._displayfield;
    }
    set displayfield(v) {
        this._displayfield = v;
    }

    get filter() {
        return this._filter;
    }
    set filter(v) {
        try {
            if (typeof v === "string") {
                this._filter = v === "" ? [] : JSON.parse(v);
            } else {
                this._filter = v;
            }
        } catch (e) {
            console.error(`cannot load filters: ${e.stack}`);
            this._filter = [];
        }
    }

    get childrenfield() {
        return this._childs || "Childs";
    }
    set childrenfield(value) {
        this._childs = value;
    }

    get filtercallback() {
        return this._filtercallback;
    }
    set filtercallback(value) {
        this._filtercallback = value;
    }

    /**
     * Цвет заливки фона активного флага
     * @type {string}
     */
    get flagbackgroundfill() {
        return this._flagbackgroundfill || "#fff";
    }

    set flagbackgroundfill(value) {
        this._flagbackgroundfill = value;
    }

    /**
     * Прозрачность флага
     * @type {number}
     */
    get flagtransparency() {
        return this._flagtransparency ?? 1;
    }

    set flagtransparency(value) {
        this._flagtransparency = value / 100;
    }

    /**
     * Размер тени флага (то есть размытие)
     * @type {number}
     */
    get flagshadowsize() {
        return this._flagshadowsize ?? 0;
    }

    set flagshadowsize(value) {
        this._flagshadowsize = +value;
    }

    /**
     * Цвет тени флага
     * @type {string}
     */
    get flagshadowcolor() {
        return this._flagshadowcolor || "transparent";
    }

    set flagshadowcolor(value) {
        this._flagshadowcolor = value;
    }

    /**
     * Вид курсора флага
     * @type {string}
     */
    get flagcursorview() {
        return this._flagcursorview || "default";
    }

    set flagcursorview(value) {
        this._flagcursorview = this.getCursor(+value);
    }

    /**
     * Радиус скругления флага
     * @type {string}
     */
    get flagradius() {
        return this._flagradius || "0px";
    }

    set flagradius(value) {
        this._flagradius = this._setValueUnit(value);
    }

    /**
     * Цвет индикатора флага
     * @type {string}
     */
    get flagindicatorcolor() {
        return this._flagindicatorcolor || "#0f7800";
    }

    set flagindicatorcolor(value) {
        this._flagindicatorcolor = value;
    }

    /**
     * Толщина рамки флага
     * @type {number}
     */
    get flagframethickness() {
        return this._flagframethickness ?? 1;
    }

    set flagframethickness(value) {
        this._flagframethickness = +value;
    }

    /**
     * Цвет рамки флага
     * @type {string}
     */
    get flagframecolor() {
        return this._flagframecolor || "#ccc";
    }

    set flagframecolor(value) {
        this._flagframecolor = value;
    }

    /**
     * Стиль рамки флага
     * @type {string}
     */
    get flagframestyle() {
        return this._flagframestyle || "solid";
    }

    set flagframestyle(value) {
        this._flagframestyle = this.getBorderStyle(+value);
    }

    /**
     * Семейство шрифта текста
     * @type {string}
     */
    get fontname() {
        return this._fontname || "Tahoma";
    }

    set fontname(value) {
        this._fontname = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Размер шрифта текста
     * @type {number}
     */
    get fontsize() {
        return this._fontsize || 12;
    }

    set fontsize(value) {
        this._fontsize = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Горизонтальное выравнивание текста
     * @type {enum}
     */
    get texthorizontalalign() {
        return this._texthorizontalalign;
    }

    set texthorizontalalign(value) {
        this._texthorizontalalign = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Вертикальное выравнивание текста
     * @type {enum}
     */
    get textverticalalign() {
        return this._textverticalalign || 1;
    }

    set textverticalalign(value) {
        this._textverticalalign = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Курсивный шрифт текста
     * @type {boolean}
     */
    get fontitalic() {
        return this._fontitalic;
    }

    set fontitalic(value) {
        this._fontitalic = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Жирность шрифта текста
     * @type {boolean}
     */
    get fontbold() {
        return this._fontbold;
    }

    set fontbold(value) {
        this._fontbold = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Многострочность текста
     * @type {boolean}
     */
    get fontmultiline() {
        return this._fontmultiline;
    }

    set fontmultiline(value) {
        this._fontmultiline = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Подчёркивание текста
     * @type {boolean}
     */
    get fontunderlined() {
        return this._fontunderlined;
    }

    set fontunderlined(value) {
        this._fontunderlined = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Цвет текста
     * @type {string}
     */
    get textcolor() {
        return this._textcolor || "#000";
    }

    set textcolor(value) {
        this._textcolor = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
 * Заливка фона текста
 * @type {string}
 */
    get textbackgroundcolor() {
        return this._textbackgroundcolor;
    }

    set textbackgroundcolor(value) {
        this._textbackgroundcolor = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Стиль дерева: 0 - "Tree" (дерево), 1 - "Buttons" (кнопки)
     * @type {number}
     */
    get treestyle() {
        return this._treestyle;
    }
    set treestyle(value) {
        this._treestyle = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Глубина отступа вложенности
     * @type {number}
     */
    get indentationdepth() {
        return this._indentationdepth;
    }

    set indentationdepth(value) {
        this._indentationdepth = +value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Вертикальный интервал между элементами
     * @type {number}
     */
    get verticalspacingbetweenitems() {
        return this._verticalspacingbetweenitems;
    }

    set verticalspacingbetweenitems(value) {
        this._verticalspacingbetweenitems = +value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Высота элемента
     * @type {number}
     */
    get itemheight() {
        return this._itemheight;
    }

    set itemheight(value) {
        this._itemheight = +value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Цвет выделенного элемента
     * @type {string}
     */
    get selecteditemcolor() {
        return this._selecteditemcolor;
    }

    set selecteditemcolor(value) {
        this._selecteditemcolor = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Цвет рамки выделенного элемента
     * @type {string}
     */
    get selecteditembordercolor() {
        return this._selecteditembordercolor;
    }

    set selecteditembordercolor(value) {
        this._selecteditembordercolor = value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Толщина рамки выделенного элемента
     * @type {number}
     */
    get selecteditemborderthickness() {
        return this._selecteditemborderthickness;
    }

    set selecteditemborderthickness(value) {
        this._selecteditemborderthickness = +value;
        if (this.inited) {
            this.update();
        }
    }

    /**
     * Стиль рамки выделенного элемента
     * @type {enum}
     */
    get selecteditemborderstyle() {
        return this._selecteditemborderstyle;
    }

    set selecteditemborderstyle(value) {
        this._selecteditemborderstyle = value;
        if (this.inited) {
            this.update();
        }
    }

    get isButtonStyle() {
        const currentTreeStyle =  window._enums.TreeStyleType[this.treestyle];
        return currentTreeStyle == window._enums.TreeStyleType.Buttons;
    }

    get realHeight() {
        return this.itemheight ? this.itemheight : this.fontsize;
    }

    get halfHeight() {
        return this.realHeight / 2;
    }

    update(updatefromstylestable = false) {
        if (!this._filter) this.filter = this.getAttribute("filter") || "";
        if (Array.isArray(this._datasource)) {
            this.setTreeProperties();
            let tree;
            if (this._rootitem) {
                const item = this.getObjects(
                    this._datasource,
                    this._rootidfield || this.idfield,
                    this._rootitem
                );
                this._datasourcefiltred = item.obj;
                const data = item.obj;
                this._main.innerHTML = "";
                if (item.path.length > 1) {
                    const path = $pr.getFullName(item.path[item.path.length - 2]);
                    if (path)
                        this._additionalPath = `${path}.`;
                }
                tree = this._genEl(data, updatefromstylestable);
            } else {
                this._datasourcefiltred = this._datasource;
                this._main.innerHTML = "";
                tree = this._genEl(this._datasource, updatefromstylestable);
            }

            if (tree !== null) {
                this._main.appendChild(tree);
            }

            this._calcSelect();
            this.addSearchbox();
        } else {
            this._main.innerHTML = "";
        }
    }

    setTreeProperties() {
        const isButtonStyle = this.isButtonStyle;
        const b = this.halfHeight > this._labelbeforewidth ? this.halfHeight : this._labelbeforewidth;
        this._main.style.setProperty("--label-before-width", `${b - 1}px`);

        this._main.style.setProperty("--selected-color", this.tryToGetUserColor(this.selecteditemcolor));
        this._main.style.setProperty("--selected-border-color", this.tryToGetUserColor(this.selecteditembordercolor));
        this._main.style.setProperty("--selected-border-thickness", `${this.selecteditemborderthickness}px`);
        this._main.style.setProperty("--selected-border-style", this.getBorderStyle(window._enums.BorderStyleType[this.selecteditemborderstyle]));

        this._main.style.setProperty("--main-tree-color", this.tryToGetUserColor(this.textcolor));
        this._main.style.setProperty("--main-tree-line-color", isButtonStyle ? "transparent" : this.tryToGetUserColor(this.textcolor));
        this._main.style.setProperty("--font-size", `${this.fontsize}px`);

        this._main.style.setProperty("--label-height", this.itemheight ? `${this.itemheight}px` : 'auto');
        this._main.style.setProperty("--label-display", isButtonStyle ? 'block' : 'inline-flex');
        this._main.style.setProperty("--label-left-padding", isButtonStyle ? '0px' : `${b}px`);
        this._main.style.setProperty("--label-bottom-padding", `${this.verticalspacingbetweenitems}px`);

        this._main.style.setProperty("--ul-display", isButtonStyle ? 'grid' : 'block');
        this._main.style.setProperty("--ul-padding-inline-start", isButtonStyle ? '0px' : `${this.indentationdepth}px`);
        this._main.style.setProperty("--ul-first-padding-inline-start", isButtonStyle ? '0px' : `${this._firstleftpadding}px`);

        this._main.style.setProperty("--cl-background-color", isButtonStyle ? 'transparent' : '#fff');
        this._main.style.setProperty("--cl-border", isButtonStyle ? 'none' : '1px solid var(--main-tree-color)');
        this._main.style.setProperty("--cl-background-image", isButtonStyle ? 'none' : 'linear-gradient(to left, #1b4964, #1b4964), linear-gradient(#1b4964, #1b4964), linear-gradient(315deg, #a0b6d8, #e8f3ff 60%, #fff 60%)');
        this._main.style.setProperty("--open-background-image", isButtonStyle ? 'none' : 'linear-gradient(#1b4964, #1b4964)');
        this._main.style.setProperty("--cl-background-size", isButtonStyle ? 'none' : '1px 50%, 50% 1px, 100% 100%');
        this._main.style.setProperty("--open-background-size", isButtonStyle ? 'none' : '50% 1px');
        this._main.style.setProperty("--cl-clip-path", isButtonStyle ? 'polygon(0 0, 50% 50%, 0 100%)' : 'none');
        this._main.style.setProperty("--open-clip-path", isButtonStyle ? 'polygon(0 25%, 100% 25%, 50% 75%)' : 'none');
        this._main.style.setProperty("--open-top", isButtonStyle ? `${-this.realHeight / 10}px` : '0');

        this._main.style.setProperty("--cl-width", `${this.halfHeight}px`);
        this._main.style.setProperty("--cl-height", `${isButtonStyle ? this.realHeight : this.halfHeight}px`);
        this._main.style.setProperty("--cl-transform", isButtonStyle ? 'none' : 'translate(-50%, 50%)');
        this._main.style.setProperty("--cl-font-size", isButtonStyle ? `${this.halfHeight}px` : '0');
    }

    getElStyle(data) {
        const result = {}
        for (let key in this.stylestableconvertations) {
            const fieldValue = data[key]
            const params = this.stylestableconvertations[key]
            for (let key in params) {
                const newKey = key.split('.')[2]
                const value = Converter.convert(params[key], fieldValue, params[key].FieldType)
                result[newKey] = value
            }
        }

        const propertyMap = {
            'Name': 'fontname',
            'Size': 'fontsize',
            'Italic': 'fontitalic',
            'Bold': 'fontbold',
            'Multiline': 'fontmultiline',
            'Stroke': 'textcolor',
            'TextBackgroundColor': 'textbackgroundcolor',
            'TextHorizontalAlignment': 'texthorizontalalign',
            'TextVerticalAlignment': 'textverticalalign',
            'Underlined': 'fontunderlined',
        };

        return Object.entries(result).reduce((acc, [key, value]) => {
            const newKey = propertyMap[key] || key;
            acc[newKey] = value;
            return acc;
        }, {})
    }

    _calcSelect() {
        if (this._multiselect && this._values) {
            const inp = this._main.querySelectorAll('input[type="checkbox"]');
            inp.forEach(el => {
                el.checked = false;
                el.indeterminate = false;
                this.setCheckboxBgColor(el, "transparent");
            });
            const isValueTypeIdentifier = this.isValueTypeIdentifier();
            this._values.forEach(val => {
                const idSelector = `input[id="${val}"]`;
                const titleSelector = `input[item-real-path="${val}"]`;
                const pathSelector = `input[data-path="${val}"]`;

                const element = isValueTypeIdentifier
                    ? this._main.querySelector(idSelector) ?? this._main.querySelector(titleSelector) ?? this._main.querySelector(pathSelector)
                    : this._main.querySelector(titleSelector) ?? this._main.querySelector(pathSelector);
                if (element) {
                    element.checked = true;
                    element.indeterminate = false;
                    this.setCheckboxBgColor(element, this.flagbackgroundfill);
                    if (this.autoselect) {
                        this._setValues(element.parentNode.closest("li"));
                    }
                }
            });
            return;
        }

        if (!this._multiselect && this.value) {
            const idSelector = `[for="${this.value}"]`;
            const titleSelector = `[item-real-path="${this.value}"]`;
            const pathSelector = `[data-path="${this.value}"]`;
            const element = this.isValueTypeIdentifier()
                ? this._main.querySelector(idSelector) ?? this._main.querySelector(titleSelector) ?? this._main.querySelector(pathSelector)
                : this._main.querySelector(titleSelector) ?? this._main.querySelector(pathSelector);
            if (element) {
                if (this._selectItem) {
                    this._selectItem.classList.remove("select");
                    const div = this._selectItem.querySelector("div");
                    if (div) {
                        const val = this.getBackgroundColor(this._selectItem) ?? this.textbackgroundcolor;
                        if (val) {
                            div.style.backgroundColor = this.tryToGetUserColor(val);
                        }
                        else {
                            div.style.backgroundColor = null;
                        }
                    }
                }
                this._selectItem = element;
                this._selectItem.classList.add("select");
                const div = this._selectItem.querySelector("div");
                if (div) {
                    const val = this.getBackgroundColor(this._selectItem) ?? this.selecteditemcolor;
                    if (val) {
                        div.style.backgroundColor = this.tryToGetUserColor(val);
                    }
                }
            }
        }
    }

    getBackgroundColor(treeItem) {
        const overrideStyles = {};
        if (this.stylestable && this.stylestable.value) {
            const treeItemid = treeItem.getAttribute("for");
            const treeItemname = treeItem.getAttribute('item-real-path');
            this.stylestable.value.forEach(item => {
                if ((this.valuetype === "0" && item.ID === treeItemid) ||
                    (this.valuetype === "1" && item.Name === treeItemname)) {
                    Object.assign(overrideStyles, this.getElStyle(item))
                }
            })
        }
        const val = overrideStyles.textbackgroundcolor;
        return val;
    }

    clearState() {
        this._openStates = undefined;
        this.saveItemState({ openStates: undefined });
        this.update()
    }

    showClearBtnTooltip() {
        this.buildTooltip(i18next.t('tree_clear_tooltip'));
        this.setTooltipPosition(this.clearBtn);
    }

    _generateChildWindows(win, winid, windowFoldersInfo, pathLevel, pathArray, elPathArray, defaultWindowId, updatefromstylestable) {
        if (typeof winid === "object") {
            const folderInfo = windowFoldersInfo ? windowFoldersInfo[win] : null;
            if (folderInfo?.AccessInNavigation === 1)
                return null;

            let windowslist = [];
            let defaultwin;
            let defaultwinpath;

            const newPathArray = [...pathArray];
            newPathArray.push(win);
            const path = `${this._additionalPath}${this.createPathFromArray(newPathArray)}`;

            const newElPathArray = [...elPathArray];
            const description = folderInfo && this.displaynametype ? folderInfo.Description || win : win;
            newElPathArray.push(description);

            for (const childwinid in winid) {
                const result = this._generateChildWindows(childwinid, winid[childwinid], folderInfo?.WindowFoldersInfo, pathLevel + 1, newPathArray, newElPathArray, defaultWindowId, updatefromstylestable);
                if (!result)
                    continue;

                if (result.defaultwin) {
                    defaultwin = result.defaultwin;
                    defaultwinpath = result.defaultwinpath;
                }

                if (result.windowslist) {
                    windowslist = windowslist.concat(result.windowslist);
                }
                else {
                    windowslist.push(result.list);
                }
            }

            if (windowslist?.length) {
                if (folderInfo?.AccessInNavigation === 2) {
                    return { defaultwin, defaultwinpath, windowslist };
                }

                const value = this.createValueNode(win, newElPathArray, false, path, path, pathLevel);
                const list = document.createElement("li");
                list.appendChild(value);
                if (this._multiselect) {
                    list.appendChild(this.createTextWrapper(description, false, path, null, "Folder", pathLevel/*, overrideStyles*/));
                }
                let savedState;
                const pathWithDescription = this.createPathFromArray(newElPathArray);
                if ((this.issavestate || this.stylestable && updatefromstylestable) && this.openStates/* && this.openStates[pathWithDescription] !== undefined*/) {
                    savedState = this.openStates[pathWithDescription]
                }

                this.addSwitcher(list, pathLevel, savedState, pathWithDescription);
                const ul = document.createElement("ul");
                windowslist.forEach(winlist => {
                    ul.appendChild(winlist)
                });
                list.appendChild(ul);

                let needToHideUl = false;
                const neetToExpand = this.expandedlevel && pathLevel >= this.expandedlevel;
                if (!this.expanded && pathLevel !== 1 || this.expanded && neetToExpand) {
                    needToHideUl = true;
                }
                const pathWithoutDescription = this.createPathFromArray(elPathArray)
                if ((this.issavestate || this.stylestable && updatefromstylestable) && this.openStates && this.openStates[pathWithoutDescription] !== undefined) {
                    needToHideUl = !this.openStates[pathWithoutDescription]
                }
                if (needToHideUl) {
                    ul.style.display = "none";
                }

                return { defaultwin, defaultwinpath, list };
            }

            return null;
        }
        else {
            const window = $WinDefs.winDef[winid];
            if (!window || window.accessInNavigation != 0) //AccessInNavigation == 0 - отображать узел
                return;
            const newPathArray = [...pathArray];
            newPathArray.push(win);
            const path = `${this._additionalPath}${this.createPathFromArray(newPathArray)}`;
            const newElPathArray = [...elPathArray];
            const description = this.displaynametype ? window.description || win : win;
            newElPathArray.push(description);
            const elpath = this.createPathFromArray(newElPathArray);

            const value = this.createValueNode(window, newElPathArray, $WinDefs.winDef[winid], path, path, pathLevel);
            const list = document.createElement("li");

            let defaultwin;
            let defaultwinpath;
            if (this._sourcetype == 4 && winid == defaultWindowId) {
                defaultwin = list;
                defaultwinpath = elpath;
            }
            list.appendChild(value);

            if (this._multiselect) {
                list.appendChild(this.createTextWrapper(description, $WinDefs.winDef[winid], path, null, "Window", pathLevel/*, overrideStyles*/));
            }
            return { defaultwin, defaultwinpath, list };
        }
    }

    _genEl(ds, updatefromstylestable, windows = [], windowFoldersInfo, pathLevel = 1, elPathArray = [], pathArray = [], defaultWindowId = null, childWindowsList = null) {
        let ul = null;
        let parentUl = null;
        let savedState;
        let defaultwin;
        let defaultwinpath;

        let windowslist = [];
        if (childWindowsList) {
            for (const childwin in childWindowsList) {
                if (!childwin.includes(".")) {
                    windows ??= [];
                    windows[childwin] = childWindowsList[childwin];
                }
            }
        }
        if (windows) {
            for (const win in windows) {
                if (win.includes(".")) {
                    childWindowsList ??= {};
                    childWindowsList[win] = windows[win];
                    continue;
                }
                if (this._sourcetype == 3 || this._sourcetype == 4) {//для дерева окон и объектов+окон добавляются окна
                    const winid = windows[win];

                    const result = this._generateChildWindows(win, winid, windowFoldersInfo, pathLevel, pathArray, elPathArray, defaultWindowId, updatefromstylestable);
                    if (!result)
                        continue;
                    if (result.defaultwin) {
                        defaultwin = result.defaultwin;
                        defaultwinpath = result.defaultwinpath;
                    }
                    if (result.windowslist) {
                        windowslist = windowslist.concat(result.windowslist);
                    }
                    else {
                        windowslist.push(result.list);
                    }
                }
            }

            if ((this._sourcetype == 3 || this._sourcetype == 4) && windowslist.length > 0) {
                ul = document.createElement("ul");
                if (!this.isButtonStyle && pathLevel == 1) {
                    ul.classList.add("first");
                }
                windowslist.forEach(winlist => {
                    ul.appendChild(winlist)
                });
                if (defaultwin) {
                    //если задано окно по умолчанию, то все остальные окна должны быть добавлены в него
                    parentUl = ul;
                    ul = null;
                    pathLevel++;
                }
            }
        }

        if (ds && Array.isArray(ds) && ds?.length) {
            for (let index = 0; index < ds.length; index++) {
                const el = ds[index];
                //AccessInNavigation == 1 - не отображать узел. Не учитывается при пользовательском дереве, дереве тренда и журнала
                if (this._sourcetype != 2 && this._sourcetype < 5 && el.AccessInNavigation === 1)
                    continue;
                let nestedUl;

                const description = this.displaynametype ? el.Description || el.Name || el[this._displayfield] : el.Name || el[this._displayfield];
                const newElPathArray = [...elPathArray];
                if (description) newElPathArray.push(description)
                const newPathArray = [...pathArray];
                newPathArray.push(el.Name)
                //newPathArray - реальный полный путь
                //newElPathArray - полный путь для дерева

                const needToAddNew = this._sourcetype == 2 || this._sourcetype == 5 || this._sourcetype == 6//для пользовательского дерева, дерева журнала и тренда все элементы добавляются в дерево
                    || (el.AccessInNavigation !== 2 &&//для остальных случаев проверяем, если AccessInNavigation != 2 (отображать только дочерние)
                        (this._sourcetype == 0//для дерева проекта
                            || (this._sourcetype == 1 || this._sourcetype == 3) && (el.Type == "ObjectInstance" || el.Type == "Object" || el.Type == "Folder")//для дерева объектов и объектов+окон добавляются объекты и непустые папки
                            || this._sourcetype == 4 && el.Type == "Folder"));//для дерева окон добавляются непустые папки
                if (el[this.childrenfield]) {
                    let addwinlist;
                    if (childWindowsList) {
                        for (const childwin in childWindowsList) {
                            if (childwin.split(".")[0] == el.Name) {
                                addwinlist ??= {};
                                addwinlist[childwin.substring(childwin.indexOf(".") + 1)] = childWindowsList[childwin];
                            }
                        }
                    }
                    nestedUl = this._genEl(el[this.childrenfield], updatefromstylestable, $pr.windMap[el.ID], el["WindowFoldersInfo"], needToAddNew ? pathLevel + 1 : pathLevel, newElPathArray, newPathArray, el.DefaultWindowID, addwinlist);
                }

                let checked = true;
                //фильтрация, используемая в дереве журнала и тренда
                if (this._filtercallback && !nestedUl) {
                    checked = this._filtercallback(el);
                }
                if (
                    checked &&
                    this._filter &&
                    Object.keys(this._filter).length > 0 &&
                    !nestedUl
                ) {
                    checked = false;
                    for (const key in this._filter) {
                        if (el.hasOwnProperty(key)) {
                            if (el[key] == this._filter[key]) {
                                checked = true;
                                break;
                            }
                        }
                    }
                    if (this.extendedSources?.includes(el.ItemPath)) checked = true
                }

                if (checked) {
                    const list = document.createElement("li");
                    const pathWithDescription = this.createPathFromArray(newElPathArray)
                    if ((this.issavestate || this.stylestable && updatefromstylestable) && this.openStates/* && this.openStates[pathWithDescription] !== undefined*/) {
                        savedState = this.openStates[pathWithDescription]
                    }
                    if (nestedUl) {
                        this.addSwitcher(list, pathLevel, savedState, pathWithDescription)
                    }

                    if (needToAddNew && (this._sourcetype != 1 && this._sourcetype != 3 && this._sourcetype != 4 || el.Type != "Folder" || nestedUl)) {
                        //для дерева объектов, окон, объектов+окон папки добаляются только непустые
                        const path = `${this._additionalPath}${this.createPathFromArray(newPathArray)}`;
                        const id = el[this.idfield];
                        const item = $pr.itemsMap[id];
                        let winPath;
                        let itemType;
                        if (item) {
                            let wins = $pr.windMap[el.ID];
                            if (childWindowsList) {
                                for (const childwin in childWindowsList) {
                                    const childWinPaths = childwin.split(".");
                                    if (childWinPaths.length == 2 && childWinPaths[0] == el.Name) {
                                        wins ??= [];
                                        wins[childWinPaths[1]] = childWindowsList[childwin];
                                    }
                                }
                            }
                            if (wins) {
                                const winName = $pr.getFirstWindow(wins, item._DefaultWindowID);
                                if (winName)
                                    winPath = `${path}.${winName}`
                            }

                            itemType = item._Type === "Array" || item._Type === "Struct" ? "Variable"
                                : item._Type === "ObjectInstance" ? "Object" : item._Type
                        }

                        const value = this.createValueNode(el, newElPathArray, this._sourcetype < 5 && itemType, winPath, path, pathLevel, itemType);
                        list.appendChild(value);
                    }
                    if (nestedUl &&
                        (el.AccessInNavigation === 2
                            || this._sourcetype == 4 && el.Type != "Folder"
                            || (this._sourcetype == 1 || this._sourcetype == 3) && (el.Type != "ObjectInstance" && el.Type != "Object" && el.Type != "Folder"))) {
                        if (ul === null) {
                            ul = nestedUl;
                        }
                        else {
                            const nestedUlchilds = [...nestedUl.children];
                            nestedUlchilds.forEach(nestedUlchild => {
                                ul.appendChild(nestedUlchild);
                            });
                        }
                    }
                    else {
                        if (nestedUl) {
                            list.appendChild(nestedUl);
                        }

                        if (list.children.length > 0) {
                            if (ul === null) {
                                ul = document.createElement("ul");
                                if (!this.isButtonStyle && pathLevel == 1) {
                                    ul.classList.add("first");
                                }
                            }
                            ul.appendChild(list);
                        }
                    }
                }
            }
        }

        if (this._sourcetype == 4 && ul && defaultwin) {
            //для дерева окон добавляем switcher в окно по умолчанию
            if ((this.issavestate || this.stylestable && updatefromstylestable) && this.openStates /*&& this.openStates[defaultwinpath] !== undefined*/) {
                savedState = this.openStates[defaultwinpath]
            }
            this.addSwitcher(defaultwin, pathLevel - 1, savedState, defaultwinpath);
            defaultwin.appendChild(ul);
        }

        let needToHideUl = false;
        const neetToExpand = this.expandedlevel && pathLevel > this.expandedlevel;
        if (!this.expanded && pathLevel !== 1 || this.expanded && neetToExpand) {
            needToHideUl = true;
        }
        const pathWithoutDescription = this.createPathFromArray(elPathArray)
        if ((this.issavestate || this.stylestable && updatefromstylestable) && this.openStates && this.openStates[pathWithoutDescription] !== undefined) {
            needToHideUl = !this.openStates[pathWithoutDescription]
        }
        if (needToHideUl && ul !== null) {
            ul.style.display = "none";
        }
        return parentUl ?? ul;
    }

    createValueNode(element, pathArray, needToAddEvent, winPath, itemPath = null, pathLevel, itemType = "Window") {
        const value = this.createLabel(element, pathArray, needToAddEvent, winPath, itemPath, itemType, pathLevel);
        if (!this._multiselect && needToAddEvent) {
            value.addEventListener("click", (e) => {
                let event = new CustomEvent("itemclick", {
                    detail: {
                        windowid: winPath,
                        item: itemPath,
                        itemtype: itemType
                    },
                });
                this.dispatchEvent(event);
                event = null;
            })
        }
        return value;
    }

    addSwitcher(list, pathLevel, savedState, path) {
        const neetToOpenSwitcher = this.expandedlevel && pathLevel >= this.expandedlevel;
        if (savedState !== undefined) {
            list.appendChild(this.createSwitcher(!savedState, path, pathLevel));
        } else {
            const isSwitcherClosed = !this.expanded || neetToOpenSwitcher;
            list.appendChild(this.createSwitcher(isSwitcherClosed, path, pathLevel));
        }
    }

    createPathFromArray(nameArr) {
        const index = nameArr.length > this.pennamelevel ? this.pennamelevel : nameArr.length
        const path = nameArr.slice(nameArr.length - index, nameArr.length).join('.')
        return path
    }

    createSwitcher(isClosed, path, pathLevel) {
        const switcher = document.createElement("div");

        if (this.isButtonStyle) {
            switcher.style.left = this._firstleftpadding - this.halfHeight / 4 + this.indentationdepth * (pathLevel - 1);
        }

        switcher.dataset.value = path;
        switcher.classList.add("cl");

        if (!isClosed) {
            switcher.textContent = "🞃";
            switcher.classList.add("open");
            switcher.classList.add("open-without-filter")
        }
        else {
            switcher.textContent = "🞂";
        }
        return switcher;
    }

    createCheckbox(forAttValue, title, itemPath) {
        const createCheckbox = document.createElement("input");
        createCheckbox.setAttribute("type", "checkbox");

        if (this.isValueTypeIdentifier() && forAttValue) {
            const nameAtt = document.createAttribute("name");
            nameAtt.value = `item${forAttValue}`;
            createCheckbox.setAttributeNode(nameAtt);

            const idAtt = document.createAttribute("id");
            idAtt.value = forAttValue;
            createCheckbox.setAttributeNode(idAtt);
        }
        if (title) {
            const titleAtt = document.createAttribute("item-title");
            titleAtt.value = title;
            createCheckbox.setAttributeNode(titleAtt);
        }
        if (itemPath) {
            const itemPathAtt = document.createAttribute("item-real-path");
            itemPathAtt.value = itemPath;
            createCheckbox.setAttributeNode(itemPathAtt);
        }

        createCheckbox.style.display = "none";
        return createCheckbox;
    }

    createCheckboxWrapper(checkboxIcon) {
        const checkboxWrapper = document.createElement("div");
        checkboxWrapper.classList.add("tree__checkbox-wrapper");
        checkboxWrapper.style.opacity = this.flagtransparency;
        if (!this.flagtransparency) {
            return checkboxWrapper;
        }

        checkboxWrapper.style.border = `${this.flagframethickness}px ${this.flagframestyle} ${this.flagframecolor}`;

        if (this.flagshadowsize && this.flagshadowcolor !== "transparent") {
            checkboxWrapper.style.boxShadow = `0px 0px ${this.flagshadowsize}px ${this.flagshadowcolor}`;
        }

        if (this.flagradius !== "0px" && this.flagradius !== "0%") {
            checkboxWrapper.style.borderRadius = this.flagradius;
        }

        checkboxWrapper.appendChild(checkboxIcon);

        return checkboxWrapper;
    }

    createCheckboxIcon() {
        const svg = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "svg"
        );
        svg.classList.add("tree__checkbox");
        svg.setAttribute("viewBox", "0 0 12 10");

        const svgNS = svg.namespaceURI;
        const path = document.createElementNS(svgNS, "path");
        path.setAttribute(
            "d",
            "M11.9142 1.41421L4.20711 9.12132L0 4.91421L1.41421 3.5L4.20711 6.29289L10.5 0L11.9142 1.41421Z"
        );
        path.setAttribute("fill", this.flagindicatorcolor);
        svg.appendChild(path);
        return svg;
    }

    createLabel(el, nameArr, needToAddEvent, winPath, itemPath = null, itemType, pathLevel) {
        const label = document.createElement("label");
        const objectid = winPath ? $pr.getObjectIdByPath(winPath).objectid : 0;
        const forAttValue = itemType === "Window" && objectid !== 0 ? null : el[this.idfield] ?? el[this._winidfield];

        const title = this.createPathFromArray(nameArr)
        const name = nameArr.pop()
        label.setAttribute('item-title', title);

        if (itemPath) {
            const itemPathAtt = document.createAttribute("item-real-path");
            itemPathAtt.value = itemPath;
            label.setAttributeNode(itemPathAtt);
        }

        if (forAttValue && this.isValueTypeIdentifier()) {
            const forAtt = document.createAttribute("for");
            forAtt.value = forAttValue;
            label.setAttributeNode(forAtt);
        }

        const overrideStyles = {};
        if (this?.stylestable && this?.stylestable?.value) {
            this?.stylestable?.value?.forEach(item => {
                if (
                    (this.valuetype === "0" && item.ID === el.ID) ||
                    (this.valuetype === "1" && item.Name === el.ItemPath)
                ) {
                    Object.assign(overrideStyles, this.getElStyle(item))
                }
            })
        }

        if (this.multiselect) {
            label.style.cursor = this.flagcursorview;
            label.appendChild(this.createCheckbox(forAttValue, title, itemPath));
            label.appendChild(
                this.createCheckboxWrapper(this.createCheckboxIcon())
            );

            const div = document.createElement("div");
            div.appendChild(label);
            
            div.appendChild(this.createTextWrapper(name, needToAddEvent, winPath, itemPath, itemType, pathLevel, overrideStyles));
            if (this.texthorizontalalign) {
                div.style.display = "flex";
            }
            return div;
        }

        if (!this._multiselect)
            label.appendChild(this.createTextWrapper(name, needToAddEvent, winPath, itemPath, itemType, pathLevel, overrideStyles));

        if (this.texthorizontalalign) {
            label.style.display = "flex";
        }

        return label;
    }

    createTextWrapper(text, needToAddEvent, winPath, itemPath, itemType, pathLevel, overrideStyles = {}) {
        const nodeType = this._multiselect ? "span" : "div";
        const div = document.createElement(nodeType);
        if (this._multiselect && needToAddEvent) {
            div.addEventListener("click", () => {
                let event = new CustomEvent("itemclick", {
                    detail: {
                        windowid: winPath,
                        item: itemPath,
                        itemtype: itemType
                    },
                });
                this.dispatchEvent(event);
                event = null;
            })
        }

        const textEl = document.createElement("text");
        textEl.textContent = text;
        div.appendChild(textEl);
        //div.textContent = text;

        const styleHandlers = {
            fontFamily: () => {
                const val = overrideStyles.fontname ?? this.fontname;
                if (val) div.style.fontFamily = `"${val}"`;
            },
            fontSize: () => {
                const val = overrideStyles.fontsize ?? this.fontsize;
                if (val) {
                    div.style.fontSize = `${val}px`;
                    div.style.lineHeight = `${val}px`;
                }
            },
            textAlign: () => {
                const val = overrideStyles.texthorizontalalign ?? this.texthorizontalalign;
                if (val !== undefined) {
                    div.style.textAlign = window._enums.AlignText[val] || val;
                    div.style.flex = "1";
                }
            },
            alignSelf: () => {
                const val = overrideStyles.textverticalalign ?? this.textverticalalign;
                if (val !== undefined) {
                    div.style.alignSelf = window._enums.AlignVertical[val] || val;
                }
            },
            fontStyle: () => {
                const val = overrideStyles.fontitalic ?? this._toBool(this.fontitalic);
                if (val !== undefined) {
                    div.style.fontStyle = val ? 'italic' : 'normal';
                }
            },
            fontWeight: () => {
                const val = overrideStyles.fontbold ?? this._toBool(this.fontbold);
                if (val !== undefined) {
                    div.style.fontWeight = val ? 'bold' : 'normal';
                }
            },
            whiteSpace: () => {
                const val = overrideStyles.fontmultiline ?? this._toBool(this.fontmultiline);
                if (val !== undefined) {
                    div.style.whiteSpace = val ? 'normal' : 'nowrap';
                }
            },
            textDecoration: () => {
                const val = overrideStyles.fontunderlined ?? this._toBool(this.fontunderlined);
                if (val !== undefined) {
                    div.style.textDecoration = val ? 'underline' : 'none';
                }
            },
            color: () => {
                const val = overrideStyles.textcolor ?? this.textcolor;
                if (val) {
                    div.style.color = this.tryToGetUserColor(val);
                }
            },
            backgroundColor: () => {
                const val = overrideStyles.textbackgroundcolor ?? this.textbackgroundcolor;
                if (val) {
                    div.style.backgroundColor = this.tryToGetUserColor(val);
                }
            },
            padding: () => {
                if (this.isButtonStyle) {
                    const b = this.halfHeight > this._labelbeforewidth ? this.halfHeight : this._labelbeforewidth;
                    const padding = this._firstleftpadding + this.indentationdepth * (pathLevel - 1) + b;
                    div.style.padding = `0 0 0 ${padding}`;
                }
            }
        };



        Object.values(styleHandlers).forEach(handler => handler());

        return div;
    }

    _loadJSON(filename, callback) {
        const xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.open("GET", filename, true);
        xobj.onreadystatechange = function () {
            if (xobj.readyState == 4 && xobj.status == "200") {
                callback(xobj.responseText);
            }
        };
        xobj.send(null);
    }

    disconnectedCallback() {
        this._filtercallback = null;
        this.controller.abort();
        super.disconnectedCallback();
    }

    getSiblings(elem) {
        var siblings = [];
        var sibling = elem.parentNode.firstChild;

        while (sibling) {
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }

        return siblings;
    }

    getObjects(obj, key, val, path = []) {
        let objects = [];
        for (let i = 0; i < obj.length; i++) {
            const el = obj[i];
            path.push(el[this.idfield]);
            if (el[key] && el[key] == val) {
                objects.push(el);
                return { obj: objects, path: path, end: true };
            } else {
                if (el[this.childrenfield].length !== 0) {
                    const ret = this.getObjects(
                        obj[i][this.childrenfield],
                        key,
                        val,
                        path
                    );
                    if (ret && ret.end) {
                        return { obj: ret.obj, path: path, end: true };
                    } else {
                        path.pop();
                        continue;
                    }
                } else {
                    path.pop();
                }
            }
        }
    }

    setCheckboxBgColor(checkbox, bgColor) {
        this.getSiblings(checkbox).find(x =>
            x.classList.contains("tree__checkbox-wrapper")
        ).style.backgroundColor = this.tryToGetUserColor(bgColor);
    }

    _onChange(event) {
        const val = event.target.checked;
        const element = event.target.closest("li");
        const tempObjectValues = [];

        if (this.autoselect) {
            const allCheckboxes = element.querySelectorAll(
                'input[type="checkbox"]'
            );
            allCheckboxes.forEach(el => {
                el.checked = val;
                el.indeterminate = false;
                this.setCheckboxBgColor(
                    el,
                    el.checked ? this.flagbackgroundfill : "transparent"
                );
            });

            this._setValues(element);
            const checkedCheckboxes = this._main.querySelectorAll(
                'input[type="checkbox"]:checked'
            );
            if (this.objectValues) {
                checkedCheckboxes.forEach(el => {
                    const hasChilds =
                        el.parentNode.closest("li").childNodes.length > 2;
                    if (!hasChilds) {
                        tempObjectValues.push({
                            id: el.id,
                            title: el.parentNode.getAttribute('item-title'),
                        });
                    }
                });
            } else {
                this._tmpValues = [];
                const isValueTypeIdentifier = this.isValueTypeIdentifier();
                checkedCheckboxes.forEach(el => {
                    const hasChilds =
                        el.parentNode.closest("li").childNodes.length > 2;
                    if (!hasChilds) {
                        this._tmpValues.push(
                            isValueTypeIdentifier
                                ? el.parentNode.getAttribute("for") ?? el.parentNode.getAttribute('item-real-path') ?? this.generatePath(el)
                                : el.parentNode.getAttribute('item-real-path') ?? this.generatePath(el)
                        );
                    }
                });
            }
        } else {
            const liArr = [...this._main.childNodes[0].childNodes];

            const getSelected = liArr => {
                let ret = [];
                liArr.forEach(el => {
                    const hasChilds = el.childNodes.length > 2;
                    const checkbox = el.childNodes[hasChilds ? 1 : 0].childNodes[0].control;
                    if (checkbox.checked) {
                        ret.push(checkbox.id);
                    } else if (el.childNodes[2]) {
                        ret = ret.concat(
                            getSelected([...el.childNodes[2].childNodes])
                        );
                    }
                });
                return ret;
            };

            this._tmpValues = getSelected(liArr);
        }

        if (!this._onapply) {
            if (this.objectValues) {
                this.SetParameter("objectValues", tempObjectValues);
            } else {
                this.SetParameter("values", this._tmpValues);
            }
        }
        this.onChange?.(this._tmpValues)
    }

    _setValues(element) {
        if (!element.parentNode.closest("li")) {
            return;
        }

        let count = 0,
            inde = 0;
        const sub = this.getSiblings(element);
        sub.forEach(el => {
            const e = el.querySelector('input[type="checkbox"]');
            count += Number(e.checked);
            inde += Number(e.indeterminate);
        });
        const curEl = element.parentNode.closest("li").querySelector(
            'input[type="checkbox"]'
        );

        if (sub.length === count) {
            curEl.indeterminate = false;
            curEl.checked = true;
        } else if (count === 0 && inde === 0) {
            curEl.checked = false;
            curEl.indeterminate = false;
        } else {
            curEl.checked = false;
            curEl.indeterminate = true;
        }

        this.setCheckboxBgColor(
            curEl,
            curEl.checked ? this.flagbackgroundfill : "transparent"
        );

        this._setValues(element.parentNode.closest("li"));
    }

    get openStates() {
        return this._openStates;
    }

    set openStates(v) {
        this._openStates = v;
    }

    _onClick(event) {
        const { target } = event;
        switch (target.nodeName) {
            case "DIV":
                if (!target.classList.contains("cl"))
                    return;
                target.classList.toggle("open");
                target.textContent = target.classList.contains("open") ? "🞃" : "🞂";
                if (!this.isFiltered) target.classList.toggle("open-without-filter");
                target.parentNode.querySelector("ul").style.display =
                    target.classList.contains("open") ? "" : "none";
                const key = target.getAttribute("data-value");
                if (this.issavestate || this.stylestable) {
                    if (!this._openStates) this._openStates = {};
                    this._openStates[key] = target.classList.contains("open") ? true : false
                    if (this.issavestate)
                        this.saveItemState({ openStates: this.openStates });
                }
                event.preventDefault();
                break;
            case "LABEL":
                if (!this._multiselect) {
                    let val;
                    if (this.isValueTypeIdentifier())
                        val = target.getAttribute("for");
                    val ??= target.getAttribute("item-real-path") ?? this.generatePath(target);
                    this.SetParameter("value", val, false, null, null, "", {
                        beforeCallbackFn: () => {
                            this._interaction = true;
                        },
                        afterCallbackFn: () => {
                            this._interaction = false;
                        },
                    });

                    event.preventDefault();
                }
                break;
        }
    }

    generatePath(target) {
        if (target.dataset.path) {
            return target.dataset.path;
        }

        let parent = target.parentNode;
        let path = "";
        while (parent.className !== "tree") {
            if (parent.tagName.toLowerCase() !== "li") {
                parent = parent.parentNode;
                continue;
            }

            const textContentControl = this._multiselect ? "span" : "label";
            const textContent = [...parent.childNodes].find(
                x => x.tagName.toLowerCase() === textContentControl
            ).textContent;

            path = textContent + (path ? this.separator + path : "");
            parent = parent.parentNode;
        }
        target.dataset.path = path;
        return path;
    }

    attributeChangedCallback(attrName, oldVal, newVal, itemIndex, forced) {
        if (attrName === "value" && !this._interaction) {
            if (this._rawValue === newVal)
                return;
            this._rawValue = newVal;
        }

        super.attributeChangedCallback(attrName, oldVal, newVal)
    }
}
